import { setCookie, getCookie, deleteCookie } from './cookie.js';
import hoverintent from '../../../default/global/js/hoverintent.js';

export function initTranslate() {

    const googleTranslateElementInit = () => {
        new window.google.translate.TranslateElement({
                pageLanguage: 'auto',
                autoDisplay: false,
                includedLanguages: "de,en,it,fr",
                layout: google.translate.TranslateElement.InlineLayout.SIMPLE
            },
            'google_translate_element');
    };

    const languages = [
        {label: 'Deutsch', abbr: 'DE', value: '/auto/de'},
        {label: 'Englisch', abbr: 'EN', value: '/auto/en'},
        {label: 'Italiano', abbr: 'IT', value: '/auto/it'},
        {label: 'Französisch', abbr: 'FR', value: '/auto/fr'}
    ];

    window.googleTranslateElementInit = googleTranslateElementInit;

    let selected = getCookie('googtrans') || '/auto/de';
    let abbreviation;

    const languageSelect = document.getElementById('changeLangSelect');

    for (let language of languages) {
        let option = document.createElement('li');
        option.innerHTML = language.label;
        option.dataset.value = language.value;
        option.classList.add('notranslate');

        if (language.value === selected) {
            option.classList.add('active');
            abbreviation = language.abbr;
        }

        languageSelect.appendChild(option);
    }

    document.querySelector('.langSwitch__activeLabel').innerHTML = abbreviation;

    for (let langOption of languageSelect.querySelectorAll('li')) {
        langOption.addEventListener('click', (event) => {
            langChange(langOption.dataset.value, event);
        });
    }

    const langChange = (value, event) => {
        event.preventDefault();

        if (value === '/auto/de') {
            deleteCookie('googtrans');
            window.location.reload();
            return;
        }

        setCookie('googtrans', decodeURI(value), 365);
        window.location.reload();
    };

    // HoverIntent native ersetzen
    hoverintent(
        document.querySelector('.langSwitch__nav'),
        200,
        () => languageSelect.style.display = 'grid',
        () => languageSelect.style.display = 'none'
    );
}